import React, { useState, useEffect, useRef } from 'react'
import Slider from 'react-slick'
import { Item, RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'gatsby'

const settings = {
  autoplay: false,
  dots: false,
  infinite: true,
  speed: 500,
  items: 3,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: `${screen.width / 10.5}px`,
  slidesToScroll: 3,
  rows: 1,
  slidesPerRow: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 992,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        items: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
}

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Compartimos la experiencia de quienes nos eligen',
  testimonialsAutoplay: false,
  testimonials: [
    {
      image: "https://images.pexels.com/photos/2531553/pexels-photo-2531553.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      paragraph: "Altamente recomendable, el equipo de Laura Farias demostró gran profesionalismo y atención constante. Estamos muy agradecidos por su servicio ejemplar. Nuestro sueño de un hogar propio, pese a los desafíos, se hizo realidad con esfuerzo y confianza. En 2020, en medio de la pandemia, decidimos invertir en un fideicomiso para un proyecto de Laura Farias. Ahora, en 2023, celebramos la creación de nuestro hermoso departamento, gracias al meticuloso trabajo del equipo. Agradecemos especialmente a Luis, Mariano y Alex por su amabilidad, y a Sebastián y Diego por su apoyo y confianza. Este proyecto ha reafirmado nuestro compromiso de seguir colaborando con Laura Farias en el futuro.",
      title: "Martina Aravena"
    },
    {
      image: "https://images.pexels.com/photos/4052800/pexels-photo-4052800.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      paragraph: "La compra de nuestro departamento de tres ambientes con terraza fue una experiencia enriquecedora gracias a Laura Farias y su equipo. Desde el inicio, mostraron una notable eficiencia y cordialidad, permitiéndonos proponer mejoras. El departamento, con su perfecta distribución y luminosidad, es ideal para disfrutar durante todo el año. Nuestro profundo agradecimiento al equipo por ayudarnos a realizar este sueño. La calidad del servicio y la atención a los detalles han sido excepcionales, reflejando el compromiso y la habilidad del equipo de Laura Farias en cada paso del proceso.",
      title: "Ayelen y Pablo, propietarios en Cochabamba 2335"
    },
    {
      image: "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      paragraph: "Mi sincero agradecimiento al equipo de Laura Farias por su excepcional trabajo en Cochabamba Unico. Han excedido nuestras expectativas con un profesionalismo y atención al detalle impresionantes. Su servicio siempre atento y dispuesto ha sido fundamental. Valoramos mucho su empeño en crear espacios de alta calidad, reflejando su dedicación a la excelencia. Reconocemos y felicitamos a Laura Farias por su destacada profesionalidad, un pilar en el mercado inmobiliario. Su trabajo no solo cumple, sino que supera, los estándares del sector, demostrando su liderazgo y compromiso.",
      title: "Alejandro Mercante, comprador en Cochabamba 2335"
    },
    {
      paragraph: "Wquas enim quasi est quidem magnam voluptate accusantium unde quasi aspernatur aut expedita occaecati aliquam odit nobis qui voluptatem quia voluptas consequuntur itaque.",
      title: "Adrienn Matt"
    }
  ],
  button: {
    link: 'https://google.com',
    value: 'Conocé nuestros servicios',
  },
}

const Testimonials = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, testimonials, testimonialsAutoplay, button } = isDemo ? MOCKDATA : props
  settings.autoplay = (testimonialsAutoplay !== undefined) ? Boolean(testimonialsAutoplay) : true

  const checkTestimonials = (testimonials: any[]) => {
      return (testimonials?.length <= 2)
            ? testimonials.concat(testimonials[0])
            : testimonials;
  }

  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 3000)
  }, [])

  const Testimony = require(`@components/testimony/1`)?.default
  const sliderRef = useRef<any>()
  const showArrow = () => {
    return window.screen.width > 992
      ? testimonials && testimonials?.length > 3
        ? 'd-block'
        : 'd-none'
      : 'd-block'
  }

  return (
    <section id="testimonials-wrapper" className={(testimonials?.length === 0 ? ' d-none' : ' p-y-config ')}>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="section-title pb-3 text-center">{title}</h2>
          </Col>
        </Row>
      </Container>
      <div className="testimonials d-flex align-items-center justify-content-center my-4">
      { load ?
          <Slider
            {...settings}
            lazyLoad="ondemand"
            className="overflow-hidden">
            { [1, 2, 3].map((index) => (
                  <Testimony
                    key={index}
                    skeleton={true}
                  />
                ))}
          </Slider> : null }
      { !load && (testimonials && testimonials?.length > 0) ?
        <>
          <Slider
              {...settings}
              ref={sliderRef}
              lazyLoad="ondemand"
              className="overflow-hidden">
              { checkTestimonials(testimonials)?.map((testimony: Item, index: number) => (
                    <Testimony
                      key={index}
                      testimony={testimony}
                    />
                  ))}
            </Slider>
            <i
              className={'icon-arrow-left isArrowFeatured ' + showArrow()}
              onClick={() => sliderRef.current.slickPrev()}
            ></i>
            <i
              className={'icon-arrow isArrowFeatured ' + showArrow()}
              onClick={() => sliderRef.current.slickNext()}
            ></i>
        </> : null }
      </div>
      { button?.link ?
        <Container fluid>
          <Row>
              <Col xs={12} className="text-center">
                  <Link to={button?.link!} className="mt-3 d-inline-block testimonials-btn btn btn-primary">
                      {button?.value}
                  </Link>
              </Col>
          </Row>
      </Container> : null }
    </section>
  )
}

export default Testimonials
